import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {AdminDashboardComponent} from "./pages/admin-dashboard/admin-dashboard.component";
import {AdminUsermanagementComponent} from "./pages/admin-usermanagement/admin-usermanagement.component";
import {
  AdminWorkstationManagementComponent
} from "./pages/admin-workstation-management/admin-workstation-management.component";
import {
  AdminProductionLineManagementComponent
} from "./pages/admin-production-line-management/admin-production-line-management.component";
import {
  ProductionLineDetailsPageComponent
} from "./pages/admin-production-line-management/production-line-details-page/production-line-details-page.component";
import {
  ProductionLineFormComponent
} from "./pages/admin-production-line-management/production-line-form/production-line-form.component";
import {
  ProductionLineViewComponent
} from "./pages/admin-production-line-management/production-line-view/production-line-view.component";
import {
  WorkstationFormComponent
} from "./pages/admin-workstation-management/workstation-form/workstation-form.component";
import {
  SelectProductionLineComponent
} from "./pages/admin-workstation-management/select-production-line/select-production-line.component";
import {UserFormComponent} from "./pages/admin-usermanagement/user-form/user-form.component";
import {UserViewComponent} from "./pages/admin-usermanagement/user-view/user-view.component";
import {AiConfigurationComponent} from "./pages/admin-ai/ai-configuration/ai-configuration.component";
import {AiConfigurationTestComponent} from "./pages/admin-ai/ai-configuration-test/ai-configuration-test.component";

const routes: Routes = [
  {
    path: "dashboard",
    component: AdminDashboardComponent,
  },
  {
    path: "users",
    component: AdminUsermanagementComponent,
    children: [
      {
        path: "",
        component: UserViewComponent,
        data: {componentName: "userViewComponent"},
      },
      {
        path: "user/:id",
        component: UserFormComponent,
        data: {componentName: "userFormComponent"},
      },
    ],
  },
  {
    path: "workstations",
    component: AdminWorkstationManagementComponent,
    children: [
      {
        path: "",
        component: SelectProductionLineComponent,
        data: {componentName: "selectProductionLineComponent"},
      },
      {
        path: "workstation/:id",
        component: WorkstationFormComponent,
        data: {componentName: "workstationFormComponent"},
      },
    ],
  },
  {
    path: "productionLines",
    component: AdminProductionLineManagementComponent,
    children: [
      {
        path: "",
        component: ProductionLineViewComponent,
        data: {componentName: "productionLineViewComponent"},
      },
      {
        path: "line/:id",
        component: ProductionLineDetailsPageComponent,
        data: {componentName: "productionLineDetailsPageComponent"},
      },
      {
        path: "inputForm",
        component: ProductionLineFormComponent,
        data: {componentName: "productionLineFormComponent"},
      },
    ],
  },
  {
    path: "ai-configuration",
    component: AiConfigurationComponent,
    data: {componentName: "aiConfigurationComponent"},
  },
  {
    path: "ai-configuration-test",
    component: AiConfigurationTestComponent,
    data: {componentName: "aiConfigurationTestComponent"},
  },
  {
    path: "**",
    redirectTo: "/admin/dashboard",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {
}
